import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 4px;
  margin-bottom: 10px;
`
